import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, computed, inject } from "@angular/core";

import { ActionService, CurrencyService } from "@services";

import { ModalInstance, ModalWithData } from "../modal/modal.interfaces";

@Component({
  templateUrl: "./max-win-modal.component.html",
  styleUrls: ["./max-win-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaxWinModalComponent implements ModalWithData, AfterViewInit {
  private readonly acS = inject(ActionService);
  private readonly eR = inject(ElementRef);

  public instance: ModalInstance;

  private readonly prefix = inject(CurrencyService).symbol;

  protected readonly max_win = computed<string>(() => `${this.prefix}${this.acS.cSB$()!.max_win}`);

  private readonly COUNT = 20;

  public ngAfterViewInit(): void {
    const COLORS = ["#f43f5e", "#10b981", "#3b82f6", "#f59e0b", "#a855f7", "#06b6d4"];

    const frag = document.createDocumentFragment();

    for (let i = 0; i < this.COUNT; i++) {
      const isCircle = Math.random() > 0.5;
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      const size = 6 + Math.random() * 7;
      const dur = 2 + Math.random() * 2.5;
      const delay = -(Math.random() * dur);

      const piece = document.createElement("div");
      piece.className = "confetti";
      piece.style.cssText = `
        left: ${Math.random() * 100}%;
        width: ${size}px;
        height: ${size}px;
        background: ${color};
        border-radius: ${isCircle ? "50%" : "2px"};
        animation-duration: ${dur}s;
        animation-delay: ${delay}s;
      `;

      frag.appendChild(piece);
    }

    this.eR.nativeElement.appendChild(frag);
  }
}
